package com.fireavert.administration.shared.logic

interface AdminNavigator {
    sealed class Destination {
        data class UserPage(val userId: Int): Destination()
        object NewUserPage: Destination()
    }

    fun navigate(destination: Destination)
}